import { AppState } from "../App";

export interface ActiveSimulation {
  uid: number;
  name: string;
  date_created: string;
  user_name: string;
  organisation_name: string;
  simulation_slug: string;
  progress: number;
  status: string;
  duration: number;
}

interface ActiveSimulationsState {
  [simulationUid: string]: ActiveSimulation;
}

export const getActiveSimulations = (state: AppState) => state.activeSimulations;

export const RECEIVE_ACTIVE_SIMULATIONS = "activeSimulations/RECEIVE_ACTIVE_SIMULATIONS";
export const UPDATE_ACTIVE_SIMULATION = "activeSimulations/UPDATE_ACTIVE_SIMULATION";
export const UPDATE_ACTIVE_SIMULATION_PROGRESS =
  "activeSimulations/UPDATE_ACTIVE_SIMULATION_PROGRESS";
export const REMOVE_INACTIVE_SIMULATION = "activeSimulations/REMOVE_INACTIVE_SIMULATION";

interface ReceiveActiveSimulations {
  type: typeof RECEIVE_ACTIVE_SIMULATIONS;
  activeSimulations: ActiveSimulation[];
}

interface UpdateActiveSimulation {
  type: typeof UPDATE_ACTIVE_SIMULATION;
  activeSimulation: ActiveSimulation;
}

interface UpdateActiveSimulationProgress {
  type: typeof UPDATE_ACTIVE_SIMULATION_PROGRESS;
  uid: number;
  progress: number;
}

interface RemoveInactiveSimulation {
  type: typeof REMOVE_INACTIVE_SIMULATION;
  uid: number;
}

type ActiveSimulationsAction =
  | ReceiveActiveSimulations
  | UpdateActiveSimulation
  | UpdateActiveSimulationProgress
  | RemoveInactiveSimulation;

export default function reducer(
  state: ActiveSimulationsState = {},
  action: ActiveSimulationsAction
) {
  switch (action.type) {
    case RECEIVE_ACTIVE_SIMULATIONS: {
      const activeSimulations: ActiveSimulationsState = {};
      action.activeSimulations.forEach((simulation) => {
        activeSimulations[simulation.uid] = simulation;
      });
      return activeSimulations;
    }
    case UPDATE_ACTIVE_SIMULATION: {
      const activeSimulation = action.activeSimulation;
      return {
        ...state,
        [activeSimulation.uid]: activeSimulation,
      };
    }
    case UPDATE_ACTIVE_SIMULATION_PROGRESS:
      return {
        ...state,
        [action.uid]: {
          ...state[action.uid],
          progress: action.progress,
        },
      };
    case REMOVE_INACTIVE_SIMULATION: {
      const newState = { ...state };
      delete newState[`${action.uid}`];
      return newState;
    }
    default:
      return state;
  }
}
